import './Checkbox.css';
import React, { JSX } from 'react';

type Props = {
  readonly label: string | (string | JSX.Element)[];
  readonly checked: boolean;
  readonly onClick: (value: boolean) => void;
  readonly disabled?: boolean;
  readonly dataCy?: string;
};

export function Checkbox({ label, checked, onClick, dataCy, disabled = false }: Props): JSX.Element {
  return (
    <label className={`checkbox ${disabled ? 'checkbox--disabled' : ''}`} data-cy={`${dataCy}-checkbox`}>
      <span>{label}</span>
      <input
        type="checkbox"
        value={checked ? 'true' : 'false'}
        checked={checked}
        disabled={disabled}
        onChange={(event) => {
          if (!disabled) {
            const value = event.target.value === 'true';
            onClick(!value);
          }
        }}
      />
      <span className="checkbox__checkmark"></span>
    </label>
  );
}
